module.exports = __webpack_public_path__ + "static/media/21ECLAC2.ff41b8ac.jpg";